import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 移动端适配
import 'amfe-flexible'

import VueClipboard from 'vue-clipboard2'

// vant
import { Button, Popup, Field, Toast, Notify, Icon, Progress, Tabs, Tab, CountDown, List } from 'vant'
Vue.use(Button).use(Popup).use(Field).use(Toast).use(Icon).use(Progress).use(Tabs).use(Tab).use(Notify)
Vue.use(VueClipboard).use(CountDown).use(List)

Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
